import MarketIcon from './component'

export default MarketIcon
